/**
 * WreathQueen Scroll Reveal Animation
 * Adds smooth fade-in animations when elements scroll into view
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px',
    staggerDelay: 100,
    animationDuration: 600
  };

  // Animation classes
  const ANIMATION_CLASSES = {
    fadeInUp: 'wq-reveal-fade-in-up',
    fadeIn: 'wq-reveal-fade-in',
    scaleIn: 'wq-reveal-scale-in',
    slideInLeft: 'wq-reveal-slide-in-left',
    slideInRight: 'wq-reveal-slide-in-right'
  };

  // CSS for reveal animations
  const revealStyles = document.createElement('style');
  revealStyles.textContent = `
    .wq-reveal {
      opacity: 0;
      transition: opacity ${CONFIG.animationDuration}ms ease-out, transform ${CONFIG.animationDuration}ms ease-out;
    }

    .wq-reveal.wq-reveal-fade-in-up {
      transform: translateY(30px);
    }

    .wq-reveal.wq-reveal-fade-in {
      transform: none;
    }

    .wq-reveal.wq-reveal-scale-in {
      transform: scale(0.95);
    }

    .wq-reveal.wq-reveal-slide-in-left {
      transform: translateX(-30px);
    }

    .wq-reveal.wq-reveal-slide-in-right {
      transform: translateX(30px);
    }

    .wq-reveal.wq-reveal-visible {
      opacity: 1;
      transform: none;
    }

    .wq-reveal-stagger {
      opacity: 0;
    }

    /* Section-specific reveals */
    .wq-brand-story .wq-reveal,
    .bestsellers-section .wq-reveal,
    .wreathqueen-categories .wq-reveal,
    .wreathqueen-newsletter .wq-reveal,
    .wreathqueen-reviews .wq-reveal,
    .wreathqueen-guarantee .wq-reveal {
      opacity: 0;
      transform: translateY(20px);
      transition: opacity 0.6s ease-out, transform 0.6s ease-out;
    }

    .wq-brand-story .wq-reveal.wq-reveal-visible,
    .bestsellers-section .wq-reveal.wq-reveal-visible,
    .wreathqueen-categories .wq-reveal.wq-reveal-visible,
    .wreathqueen-newsletter .wq-reveal.wq-reveal-visible,
    .wreathqueen-reviews .wq-reveal.wq-reveal-visible,
    .wreathqueen-guarantee .wq-reveal.wq-reveal-visible {
      opacity: 1;
      transform: translateY(0);
    }

    /* Hero specific - only animate on page load, not scroll */
    .wreathqueen-hero .wq-reveal {
      opacity: 0;
      transform: translateY(20px);
      animation: heroReveal 0.8s ease-out forwards;
    }

    .wreathqueen-hero .wq-reveal:nth-child(1) { animation-delay: 0.2s; }
    .wreathqueen-hero .wq-reveal:nth-child(2) { animation-delay: 0.35s; }
    .wreathqueen-hero .wq-reveal:nth-child(3) { animation-delay: 0.5s; }
    .wreathqueen-hero .wq-reveal:nth-child(4) { animation-delay: 0.65s; }
    .wreathqueen-hero .wq-reveal:nth-child(5) { animation-delay: 0.8s; }

    @keyframes heroReveal {
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    /* Counter animation for stats */
    .wq-stat-number {
      display: inline-block;
    }
  `;
  document.head.appendChild(revealStyles);

  // Intersection Observer for scroll reveal
  let observer = null;

  function initScrollReveal() {
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const el = entry.target;

            // Handle stagger children
            if (el.classList.contains('wq-reveal-stagger')) {
              const children = el.querySelectorAll('.wq-reveal-child');
              children.forEach((child, index) => {
                setTimeout(() => {
                  child.classList.add('wq-reveal-visible');
                }, index * CONFIG.staggerDelay);
              });
              el.classList.add('wq-reveal-visible');
            } else {
              el.classList.add('wq-reveal-visible');
            }

            // Unobserve after animation
            observer.unobserve(el);
          }
        });
      }, {
        threshold: CONFIG.threshold,
        rootMargin: CONFIG.rootMargin
      });

      // Observe all reveal elements
      document.querySelectorAll('.wq-reveal, .wq-reveal-stagger').forEach(el => {
        observer.observe(el);
      });

      // Also observe elements that should trigger on scroll
      observeSections();
    } else {
      // Fallback for browsers without IntersectionObserver
      document.querySelectorAll('.wq-reveal, .wq-reveal-stagger').forEach(el => {
        el.classList.add('wq-reveal-visible');
      });
    }
  }

  function observeSections() {
    // Add reveal classes to major sections
    const sections = [
      '.wq-brand-story',
      '.bestsellers-section',
      '.wreathqueen-categories',
      '.wreathqueen-newsletter',
      '.wreathqueen-reviews',
      '.wreathqueen-guarantee'
    ];

    sections.forEach(selector => {
      const section = document.querySelector(selector);
      if (section) {
        // Add reveal class to direct children
        const children = section.children;
        Array.from(children).forEach(child => {
          if (!child.classList.contains('wq-reveal')) {
            child.classList.add('wq-reveal');
            observer.observe(child);
          }
        });
      }
    });
  }

  // Counter animation for statistics
  function animateCounter(element, target, duration) {
    const start = 0;
    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeOut = 1 - Math.pow(1 - progress, 3);
      const current = Math.floor(start + (target - start) * easeOut);

      element.textContent = current;

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }

    requestAnimationFrame(update);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    // Small delay to ensure all sections are rendered
    setTimeout(initScrollReveal, 100);
  }

  // Expose API
  window.wqReveal = {
    observe: function(el) {
      if (observer && el) {
        observer.observe(el);
      }
    },
    refresh: function() {
      if (observer) {
        observer.disconnect();
        initScrollReveal();
      }
    }
  };

  // Accordion functionality for product metafields
  function initAccordion() {
    const accordionRows = document.querySelectorAll('.wq-acc-row');

    accordionRows.forEach(row => {
      row.addEventListener('click', function() {
        const contentId = this.getAttribute('data-acc-content');
        const content = document.getElementById(contentId);
        const icon = this.querySelector('.wq-acc-ico');
        const isOpen = content && content.style.display === 'block';

        // Close all others
        accordionRows.forEach(r => {
          const id = r.getAttribute('data-acc-content');
          const c = document.getElementById(id);
          const i = r.querySelector('.wq-acc-ico');
          if (c) c.style.display = 'none';
          if (i) i.textContent = '+';
        });

        // Toggle current
        if (!isOpen && content) {
          content.style.display = 'block';
          if (icon) icon.textContent = '−';
        }
      });
    });

    // Open first item by default
    const firstRow = document.querySelector('.wq-acc-row');
    const firstContent = firstRow ? document.getElementById(firstRow.getAttribute('data-acc-content')) : null;
    const firstIcon = firstRow ? firstRow.querySelector('.wq-acc-ico') : null;
    if (firstContent) {
      firstContent.style.display = 'block';
      if (firstIcon) firstIcon.textContent = '−';
    }
  }

  // Initialize accordion when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }
})();
